import { render, staticRenderFns } from "./CreateMediaAsset.vue?vue&type=template&id=2bbbec34"
import script from "./CreateMediaAsset.vue?vue&type=script&lang=js"
export * from "./CreateMediaAsset.vue?vue&type=script&lang=js"
import style0 from "./CreateMediaAsset.vue?vue&type=style&index=0&id=2bbbec34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports